import React from 'react';

class Footer extends React.Component {
    render() {
        return (
            <div id="footer" className="footer">
                <div className="pull-right">
                    Copyright <strong> <a style={{ color: "#1ab394" }} href="https://reva.la">Reva Sports & Bookings LLC </a></strong> © {new Date().getFullYear()}
                </div>
            </div>
        )
    }
}

export default Footer